import { InsuredElementApi } from './insuredElement.api';

const insuredElementApi = new InsuredElementApi();

export { insuredElementApi };
